/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import { uniqBy, filter, map, groupBy, get, set, toArray, sortBy } from 'lodash';
import { SINGER_PROFESSION_TYPE_ID } from '../../constants/consts';

const mapIfNeed = (data, mapHandler) => (mapHandler ? map(data, mapHandler) : data);

const getEntriesByComposer = (collection, composerId, mapHandler) =>
  mapIfNeed(
    filter(collection, entry => entry?.work?.composer?.id === composerId),
    mapHandler,
  );

const getEntriesByWork = (collection, workId, mapHandler) =>
  mapIfNeed(
    filter(collection, entry => entry?.work?.id === workId),
    mapHandler,
  );

const getWorks = collection => map(collection, element => element?.work);

const getComposers = collection => map(collection, element => element?.work?.composer);

const getUniqComposers = (collection, mapHandler) =>
  mapIfNeed(
    uniqBy(getComposers(collection), c => c?.id),
    mapHandler,
  );

const getUniqWorks = (collection, mapHandler) =>
  mapIfNeed(
    uniqBy(getWorks(collection), w => w?.id),
    mapHandler,
  );

const getLastUpdated = collection =>
  collection
    .map(entry => new Date(entry?.updatedAt))
    .sort()
    .reverse()[0];

export const profileRepertoireResponseToUxRepresentation = data => {
  const collection = data?.data || [];

  return {
    lastUpdated: {
      date: getLastUpdated(collection),
    },
    composers: [
      ...getUniqComposers(collection, composer => ({
        composer: {
          id: composer?.id,
          name: composer?.name,
          slug: composer?.slug,
        },
        works: [
          ...getUniqWorks(getEntriesByComposer(collection, composer?.id), w => ({
            name: w?.name,
            id: w?.id,
            slug: w?.slug,
            roles: [
              ...getEntriesByWork(collection, w.id, e => ({
                repertoireId: e?.id,
                profession: e?.profession && e.profession.id !== SINGER_PROFESSION_TYPE_ID ? e.profession : null,
                production: {
                  name: e?.production?.name,
                },
                year: e?.startYear,
                vocal: {
                  type: e?.workRole?.professionQualification?.name,
                },
                ...e,
              })).sort((r1, r2) => (r1?.name?.toUpperCase() > r2?.name?.toUpperCase() ? 1 : -1)),
            ],
          })),
        ],
      })),
    ],
  };
};

export const groupRepertoireRecords = repertoire => {
  const groupedByComposer = groupBy(repertoire, 'work.composer.id');
  const data = {};
  for (const composerId in groupedByComposer) {
    const works = get(groupedByComposer, composerId);
    const composer = get(works, '[0].work.composer');
    const groupedWorks = groupBy(works, 'work.id');
    const worksStructured = {};
    for (const workId in groupedWorks) {
      const roles = get(groupedWorks, workId);
      const workInfo = get(roles, '[0].work');
      set(worksStructured, workId, { work: workInfo, data: toArray(roles) });
    }
    set(data, composerId, { composer, data: sortBy(toArray(worksStructured), r => r?.work?.name?.toUpperCase()) });
  }
  return sortBy(toArray(data), c => c?.composer?.name?.toUpperCase());
};
